import { Flex } from 'foundations-components/components/Flex';
import BulkActions from 'framework-listing-lib/internal/Table/components/BulkActions';
import TableSkeleton from 'framework-listing-lib/internal/Table/components/TableSkeleton';
import TableTopBar from 'framework-listing-lib/internal/Table/components/TableTopBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibFrameworkDataTableSkeleton({
  hasTopBar,
  rowProps
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "crm-table-skeleton",
    flexDirection: "column",
    inlineSize: "100%",
    children: [hasTopBar && /*#__PURE__*/_jsx(TableTopBar, {
      middleSlot: /*#__PURE__*/_jsx(BulkActions, {
        hasBulkActions: false,
        isTableActionsOpen: false,
        selectedObjectsCount: 0
      }),
      isLoading: true
    }), /*#__PURE__*/_jsx(TableSkeleton, {
      rowProps: rowProps
    })]
  });
}